<svg
  role="img"
  xmlns="http://www.w3.org/2000/svg"
  [attr.aria-label]="ariaLabel"
  [attr.aria-hidden]="ariaHidden"
  [attr.aria-describedby]="ariaDescribedby"
  [attr.width]="width"
  [attr.height]="height"
  [attr.viewBox]="viewBox"
  [innerHTML]="paths"
></svg>
